import { httpClient } from './httpClient';

const base = '/api/documentos-analisis';

export const listarDocumentosAnalisis = (params = {}) =>
  httpClient.get(base, { params });

export const obtenerAnalisisDocumento = (documentoId) =>
  httpClient.get(`${base}/${documentoId}/analisis`);

export const retryAnalisisDocumento = (documentoId) =>
  httpClient.post(`${base}/${documentoId}/analisis/retry`);

const documentoAnalisisService = {
  listar: listarDocumentosAnalisis,
  obtenerAnalisis: obtenerAnalisisDocumento,
  retry: retryAnalisisDocumento,
};

export default documentoAnalisisService;
